module.exports = __webpack_public_path__ + "6a7e253c46e22e5217368d5bcc516140.svg";